/**
 * Puma
 * @category    ScandiPWA
 * @author      Ricards Nedosvitnijs <info@scandiweb.com>
 * @copyright   Copyright (c) 2021 Scandiweb, Ltd (https://scandiweb.com)
 */

import { STORE_CODE_KSA_AR, STORE_CODE_KSA_EN } from 'Component/Router/Router.config';
import BrowserDatabase from 'Util/BrowserDatabase';

/** @namespace Scandipwa/Util/Arabic/isKsa/isKsa */
export const isKsa = () => (BrowserDatabase.getItem('config')?.storeConfig?.code
    ? BrowserDatabase.getItem('config').storeConfig.code === STORE_CODE_KSA_EN
    || BrowserDatabase.getItem('config').storeConfig.code === STORE_CODE_KSA_AR
    : false);

export default isKsa;
